module.exports = __webpack_public_path__ + "img/partnerships.297c08ea.png";